import React, { useState } from "react";
import classnames from "classnames";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const PerformanceAnalysisChampionTabs = (props) => {
  const { getChampionImg } = getRiotAssetsContext();
  const { tabsData } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedChampionIndex, setSelectedChampionIndex] = useState(0);

  const onTabClick = (e, index, callback) => {
    e.stopPropagation();
    callback(index, 0);
    setSelectedIndex(index);
    setSelectedChampionIndex(0);
  };

  const onChampionClick = (e, index, championIndex, callback) => {
    e.stopPropagation();
    callback(index, championIndex);
    setSelectedIndex(index);
    setSelectedChampionIndex(championIndex);
  };

  return (
    <div className="tabs-container">
      <div className="tabs">
        {tabsData.map((tabData, index) => {
          const selectedStyle = index === selectedIndex ? "chosen" : "";
          return (
            <div key={index} className={`tab ${selectedStyle}`} onClick={(e) => onTabClick(e, index, tabData.callback)}>
              <div className="tabs-text">{tabData.label}</div>
              <div className="tabs_champions">
                {tabData.champions.map((champion, championIndex) => {
                  const championClassNames = classnames({
                    champion: true,
                    chosen: index === selectedIndex && championIndex === selectedChampionIndex,
                    inactive: index !== selectedIndex,
                  });
                  const selectedStyle = index === selectedIndex && championIndex === selectedChampionIndex ? "chosen" : "";
                  return (
                    <div key={champion} className={championClassNames}>
                      <div className="champion-image" onClick={(e) => onChampionClick(e, index, championIndex, tabData.callback)}>
                        <img src={getChampionImg(champion)} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisChampionTabs;
